import React, {} from "react";

import ReconnectingWebSocket from "reconnecting-websocket";

import CircularProgress from "@mui/joy/CircularProgress";
import Badge from "@mui/joy/Badge";
import IconButton from "@mui/joy/IconButton";

// components
import withNavigate from "../../utils/withNavigate";
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";

//
import NotificationsIcon from '@mui/icons-material/Notifications';


class NotificationButton extends React.Component {
    static contextType = UserSubscriberContext
    
    constructor(props) {
        super(props);
        this.state = {
            count: null
        };
    }

    async componentDidMount() {
        await this.retrieveNotifications();
        let tokens;
        if (typeof localStorage.getItem("authTokens") === 'string'){
            tokens = JSON.parse(localStorage.getItem("authTokens"));
        }
        else {
            tokens = localStorage.getItem("authTokens");
        }
        this.client = new ReconnectingWebSocket(
            `${process.env.REACT_APP_WS_HOST}/ws/notification/${this.context.userObject.id}/`,
            [],
            {
                maxRetries: 10,
            }
        );
        this.client.onopen = () => {
            this.client.send(JSON.stringify({
                type: 'authenticate',
                access_token: tokens.access,
                refresh_token: tokens.refresh
            }));
            console.log("WebSocket Client Connected");
            this.retrieveNotifications()
            this.timer = setInterval(
                () => {
                    this.client.send(
                        JSON.stringify(
                            {
                                type: 'ping',
                            }
                        )
                    )
                },
                5000
            );
        };
        this.client.onclose = () => {
            console.log("WebSocket Client Disconnected");
            this.retrieveNotifications()
        }
        this.client.onmessage = (message) => {
            this.handleMessage(message);
        };
    }

    handleMessage(message) {
        let data
        if (typeof message.data === 'string'){
            data = JSON.parse(message.data);
        }
        else {
            data =message.data;
        }

        switch (data.type) {
            case 'auth_success':
                console.log('Authenticated as', data.username);
                if (data.new_access_token) {
                    let tokens = JSON.parse(localStorage.getItem("authTokens"));
                    if (data.access_token){
                        tokens.access = data.access_token;
                    }
                    localStorage.setItem('authTokens', JSON.stringify(tokens));
                }
                break;

            case 'auth_error':
                console.error('Auth Error:', data.message);
                this.socket.close();
                break;

            case 'count':
                this.setState({
                    count: data.count,
                });
                break;

            case 'error':
                console.error('Server Error:', data.message);
                break;
        }
    }

    componentWillUnmount() {
        if (this.client){
            this.client.close();
        }
        if (this.timer){
            clearInterval(this.timer);
        }
    }

    async retrieveNotifications() {
        const api = new BaseApi();
        let response = await api.get(
            'notification/',
            {
                is_read: 0,
                page_size: 10000,
            }
        );
        this.setState(
            {
                count: response.data.count,
            }
        );
    }

    render() {
        if (this.state.count === null || this.state.count === undefined) {
            return (<CircularProgress />)
        }
        return(
            <Badge badgeContent={this.state.count} color="danger">
                 <IconButton
                    onClick={() => this.props.navigate('/notification')}
                    size={'sm'}
                 >
                     <NotificationsIcon fontSize={'small'}/>
                 </IconButton>
            </Badge>
        )
    }
}

export default withNavigate(NotificationButton);
